"use client"

import React from "react"
import { QueryClientProvider, QueryClient } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { SnackbarProvider, useSnackbar } from "notistack"
import { IconButton, ThemeProvider, createTheme } from "@mui/material"
import { CloseOutlined } from "@mui/icons-material"
import themeOptions from "@/style/theme"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { SucursalProvider } from "./SucursalProvider"
import { PostHogProvider } from "./PostHogProvider"

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: false
    },
    queries: {
      retry: false,
      refetchOnWindowFocus: false
    }
  }
})

const theme = createTheme(themeOptions("light"))

function Providers({ children }: React.PropsWithChildren) {
  return (
    <PostHogProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ThemeProvider theme={theme}>
          <QueryClientProvider client={queryClient}>
            <SnackbarProvider maxSnack={3} action={(snackbarKey) => <SnackbarCloseButton snackbarKey={snackbarKey} />}>
              <SucursalProvider>{children}</SucursalProvider>
            </SnackbarProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </PostHogProvider>
  )
}

function SnackbarCloseButton({ snackbarKey }: any) {
  const { closeSnackbar } = useSnackbar()

  return (
    <IconButton onClick={() => closeSnackbar(snackbarKey)}>
      <CloseOutlined />
    </IconButton>
  )
}

export default Providers
